<template>
  <v-container>
    <v-layout justify-center>
      <v-flex
        xs12
        sm10
        md8
        lg6
        class="v-card v-sheet theme--light"
      >
        <div class="px-5 pt-4 pb-3 grid-container">
          <label for="name">お名前</label>
          <span>：</span>
          <span
            id="name"
            class="field"
          >
            {{ user.name }}
          </span>
          <label for="company">所属</label>
          <span>：</span>
          <span
            id="company"
            class="field"
          >
            {{ group.name }}
          </span>
          <!-- <label for="email">メールアドレス</label>
          <span>：</span>
          <div class="email-box">
            <v-text-field
              id="email"
              v-model="email"
              :error-messages="emailError"
            />
          </div> -->
        </div>
        <v-divider />
        <div style="position: relative;">
          <v-layout
            :key="uniqueKey"
            justify-center
            align-center
            class="pass"
            :class="changePass ? 'pass-toggled' : ''"
          >
            <v-flex xs5>
              <v-text-field
                v-model.trim="currentPass"
                label="現在のパスワード"
                :append-icon="visibility.currentPass ? 'mdi-eye' : 'mdi-eye-off'"
                :type="visibility.currentPass ? 'text' : 'password'"
                @click:append="visibility.currentPass = !visibility.currentPass"
              />
              <v-text-field
                v-model.trim="newPass1"
                label="新しいパスワード"
                :append-icon="visibility.newPass1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min]"
                :type="visibility.newPass1 ? 'text' : 'password'"
                hint="8文字以上で入力してください。"
                @click:append="visibility.newPass1 = !visibility.newPass1"
                @input="resetConformPassword"
              />
              <v-text-field
                v-model.trim="newPass2"
                label="新しいパスワード（確認用）"
                :append-icon="visibility.newPass2 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min, rules.match]"
                :type="visibility.newPass2 ? 'text' : 'password'"
                @click:append="visibility.newPass2 = !visibility.newPass2"
              />
            </v-flex>
          </v-layout>
          <v-divider
            v-show="changePass"
          />
          <v-layout justify-center>
            <v-spacer />
            <v-btn
              v-if="changePass"
              :disabled="!isValidPasswordRequest"
              color="success"
              flat
              :loading="loading.pass"
              @click="updatePassword"
            >
              {{ '変更する' }}
            </v-btn>
            <!--Delete when putting the '保存する' button back in -->
            <v-btn
              v-else
              flat
              disabled
            >
&nbsp;
            </v-btn>
            <!-- <v-btn
              v-else
              color="success"
              flat
              @click="updateProfile"
            >
              {{ '保存する' }}
            </v-btn> -->
            <v-spacer />
          </v-layout>
          <v-btn
            flat
            class="px-2 pass-trigger-btn"
            absolute
            right
            @click="togglePassExpantion"
          >
            パスワード変更
            <v-icon
              color="grey"
              class="ml-1 down-icon"
            >
              {{ changePass ? 'mdi-chevron-up-circle-outline' : 'mdi-chevron-down-circle-outline' }}
            </v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { api } from '@/api.js'

export default {
  data () {
    return {
      email: '',
      emailError: [],
      changePass: false,
      currentPass: '',
      newPass1: '',
      newPass2: '',
      visibility: {
        currentPass: false,
        newPass1: false,
        newPass2: false
      },
      rules: {
        required: value => !!value || '入力必須項目です。',
        min: v => v.length >= 8 || '8文字以上で入力してください。',
        match: v => v === this.newPass1 || '新しいパスワードとマッチしません。'
      },
      loading: {
        pass: false
      },
      uniqueKey: 0
    }
  },
  computed: {
    ...mapState('app', ['user']),
    ...mapState('groups', ['group']),
    isValidPasswordRequest () {
      return this.currentPass.length >= 8 && this.newPass1.length >= 8 && this.newPass1 === this.newPass2
    }
  },
  methods: {
    togglePassExpantion () {
      this.changePass = !this.changePass
      this.emailError = []
    },
    // updateProfile () {
    //   if (!this.validEmail()) {
    //     this.emailError.push('正しいメールアドレスを入力してください。')
    //   }
    // },
    async updatePassword () {
      if (!this.isValidPasswordRequest) return

      this.loading.pass = true
      try {
        await api.setUserPassword(
          {
            oldPassword: this.currentPass,
            newPassword: this.newPass1
          }, this.user.id)
        this.onSuccessPassUpdate()
      } finally {
        this.loading.pass = false
      }
    },
    onSuccessPassUpdate () {
      this.currentPass = ''
      this.newPass1 = ''
      this.newPass2 = ''
      this.$store.commit('app/setGlobalSnackBarText', 'パスワードを変更しました。')
      this.changePass = false
      setTimeout(() => { ++this.uniqueKey }, 300)
    },
    // validEmail () {
    //   const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    //   return pattern.test(this.email)
    // },
    resetConformPassword (e) {
      if (this.newPass2 && e !== this.newPass2) {
        this.newPass2 = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.grid-container {
  display: grid;
  grid-template-rows: repeat(2, 60px);
  grid-template-columns: max-content 1.4rem 1fr;
  justify-items: center;
  align-items: center;
  color: var(--metal-grey-d);
}
label {
  text-align: right;
}
.email-box {
  min-width: 230px;
  /deep/.v-input__slot {
    margin-bottom: 6px;
  }
  /deep/.v-messages__message {
    font-size: 0.625rem;
  }
}
.pass-trigger-btn {
  top: 0;
  .down-icon {
    transition: transform 0.2s !important;
  }
  &:hover .down-icon {
    transform: translateY(-2px);
  }
  &:active .down-icon {
    transform: translateY(0);
  }
}

.v-text-field /deep/input {
  padding: 0.5rem 1rem;
}
.pass {
  visibility: hidden;
  transition: height 0.3s, transform 0.3s;
  height: 0;
  transform: scaleY(0);
  transform-origin: top;

  &-toggled {
    visibility: visible;
    height: 18rem;
    transform: scaleY(1);
  }
}
/deep/.v-snack__wrapper {
  min-width: 100px !important;
}
</style>
